module.exports = __webpack_public_path__ + "media/event_timber.fd41cbaf.mp3";